import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { Tabs, Tab } from "../../components/Tab";

const ServiceKioskPage = () => {
  const [isVisible, setIsVisible] = useState<boolean[]>([false]);

  // text 애니메이션
  const hideRefs = [
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      hideRefs.forEach((ref, index) => {
        const element = ref.current;
        if (element) {
          const elementTop = element.offsetTop;
          const elementHeight = element.offsetHeight;
          const isElementVisible =
            scrollTop + windowHeight > elementTop &&
            scrollTop < elementTop + elementHeight;
          setIsVisible((prev) => {
            const newVisible = [...prev];
            newVisible[index] = isElementVisible;
            return newVisible;
          });
        }
      });

      if (scrollTop + windowHeight === documentHeight) {
        setIsVisible((prev) => {
          const newVisible = [...prev];
          newVisible[newVisible.length - 1] = true;
          return newVisible;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <Style>
      <div className="wrap">
        <div className="bannerTitle mobileView">
          <h1
            ref={hideRefs[4]}
            className={` ${isVisible[4] ? "in_view fade_in" : "fade_in"}`}
          >
            KIOSK
          </h1>
          <h2>주문하고 픽업 받을 때까지 알려드립니다.</h2>
        </div>
        <div className="banner">
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKioskImage01.png"
            alt="비하인드 키오스크"
            className="behindKiosk01"
          />
        </div>
        <div className="contentWrap">
          <div className="content">
            <h1
              ref={hideRefs[0]}
              className={` ${isVisible[0] ? "in_view fade_up" : "fade_up"}`}
            >
              색상 커스터마이징 가능
            </h1>
            <h2>나만의 컬러를 선택해보세요!</h2>
            <div className="customTabWrap">
              <Tabs>
                <Tab label="#BLUE">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKioskImage02-1.png"
                    alt="디자인,색상 커스터마이징 가능한 키오스크"
                    className="behindKios02"
                  />
                </Tab>
                <Tab label="#RED">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKioskImage02-2.png"
                    alt="디자인,색상 커스터마이징 가능한 키오스크"
                    className="webPos04"
                  />
                </Tab>
                <Tab label="#GREEN">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKioskImage02-3.png"
                    alt="디자인,색상 커스터마이징 가능한 키오스크"
                    className="behindKios02"
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
          <div className="content">
            <h1
              ref={hideRefs[1]}
              className={` ${isVisible[1] ? "in_view fade_up" : "fade_up"}`}
            >
              다양한 디자인
            </h1>
            <h2>
              매장 인터리어에 맞게 다양한 크기, 디자인의 키오스크가 있습니다.
              <br />
              스마트스토어에서 확인하세요
            </h2>
            <div className="subTabWrap">
              <Tabs>
                <Tab label="21인치 키오스크">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKioskImage03-1.png"
                    alt="21인치 키오스크"
                    className="behindKios03"
                  />
                </Tab>
                <Tab label="NTP-10">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKioskImage03-2.png"
                    alt="NTP-10"
                    className="behindKios04"
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
          <div className="content">
            <h1
              ref={hideRefs[2]}
              className={` ${isVisible[2] ? "in_view fade_up" : "fade_up"}`}
            >
              단골이 늘어나는 고객 마케팅
            </h1>
            <h2>
              매장에 이벤트가 있거나 고객이 포인트를 적립하면
              <br />
              카카오톡 알림톡이 발송됩니다.
            </h2>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webPosImage05.png"
              alt="고객마케팅이 가능해 단골을 사로잡을 수 있는 키오스크"
              className="behindKios05"
            />
          </div>
        </div>
        <div className="footerContent">
          <h4>우리매장 매출 높여줄 키오스크</h4>
          <h3
            ref={hideRefs[3]}
            className={` ${isVisible[3] ? "in_view fade_in" : "fade_in"}`}
          >
            지금 바로 구매하세요!
          </h3>
          <button>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webKioskImage04.png"
              alt="비하인드 키오스크"
              className="behindKios06"
            />
          </button>
        </div>
      </div>
    </Style>
  );
};

export default ServiceKioskPage;
const Style = styled.div`
  h1,
  h2,
  h3,
  h4 {
    text-align: center;
  }
  h1 {
    font-size: 36px;
    font-weight: 700;
    line-height: 50px;
    color: #333;
  }
  h2 {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    color: #979797;
  }
  h3 {
    font-size: 68px;
    font-weight: 700;
    line-height: 95px;
  }
  h4 {
    font-size: 36px;
    font-weight: 500;
    color: #979797;
    line-height: 50px;
  }

  /* wrap */
  .wrap {
    width: 100%;
    max-width: 100%;
    margin-top: 100px;

    img {
      width: 100%;
    }
  }

  /* banner */
  .banner {
    width: 100%;
  }

  /* contentWrap */
  .contentWrap {
    width: 100%;
    padding: 60px 30%;

    .content {
      padding: 120px 0;

      h1 {
        margin-bottom: 32px;
      }
      img {
        margin-top: 50px;
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;

    h1,
    img {
      margin: 0 !important;
    }
  }

  /* footerContent */
  .footerContent {
    text-align: center;
    h3 {
      display: inline-flex;
      padding: 20px 0 60px 0;
      background: linear-gradient(90deg, #4dd2ae 10%, #ff8a00 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      color: transparent;
    }
    h4 {
      margin-top: 60px;
    }
  }

  /* customTabWrap */
  .customTabWrap {
    display: flex;
    justify-content: center;
    img {
      width: 446px;
    }
  }
  .customTabWrap .tabWrap {
    padding-top: 15px;
    .tabContent {
      display: flex;
      justify-content: center;
      align-items: end;
      width: 90px;
      height: 90px;
      padding: 9px;
      background: #3538cd;
      border-radius: 10px;
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .tabContent:nth-child(1) {
      background: #3538cd;
    }
    .tabContent:nth-child(2) {
      background: #b42311;
    }
    .tabContent:nth-child(3) {
      background: #107569;
    }
    .tabContent.active:nth-child(1) {
      background: #2a2da4;
    }
    .tabContent.active:nth-child(2) {
      background: #901c0e;
    }
    .tabContent.active:nth-child(3) {
      background: #0d5e54;
    }
    .tabContent.active {
      position: relative;
      padding: 4px;
      border: 6px solid #333;
      font-size: 12px;
    }
  }
  .customTabWrap {
    .tabContent.active {
      position: relative;
    }
    .activeCheckIcon {
      width: 55px !important;
      margin-top: 0 !important;
      display: block;
      position: absolute;
      top: 10%;
      left: 19%;
      z-index: 9999;
    }
  }

  @media (max-width: 1100px) {
    h1 {
      font-size: 28px;
      font-weight: 700;
    }
    h2 {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      word-break: keep-all;
    }
    h3 {
      font-size: 32px;
      line-height: 44px;
    }
    h4 {
      font-size: 18px;
      line-height: 25px;
    }
    .wrap {
      margin-top: 70px;
    }
    .bannerTitle {
      h1 {
        font-size: 70px;
        line-height: 48px;
      }
      h2 {
        margin: 30px 0 40px 0;
        font-size: 16px;
        line-height: 25px;
      }
    }
    .contentWrap {
      padding: 40px 5vw;

      .content {
        padding: 40px 0;

        h1 {
          margin-bottom: 12px;
        }

        img {
          margin-top: 30px;
        }
      }
      .content:nth-child(2) {
        h2 {
          padding: 0 10%;
          word-break: keep-all;
        }
      }
    }
    .subTabWrap {
      min-height: 280px;

      .tabWrap {
        gap: 12px;

        .tabContent,
        .tabContent.active {
          padding: 14px 30px !important;
          font-size: 16px;
        }
      }
    }
    .customTabWrap {
      min-height: 450px;
      text-align: center;
      img {
        width: 70%;
      }
    }
    .customTabWrap .tabWrap {
      .tabContent,
      .tabContent.active {
        width: 72px;
        height: 72px;
      }
      .activeCheckIcon {
        width: 38px !important;
      }
    }

    .footerContent {
      h3 {
        padding: 7px 5vw 30px 5vw;
      }
      h4 {
        margin-top: 0;
      }
    }

    /* 이미지 변경 */
    .behindKiosk01 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileKioskImage01.png");
    }
    .behindKios05 {
      padding: 5vw;
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileKdsImage02.png");
    }
    .behindKios06 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileKioskImage02.png");
    }
  }
`;
